import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as R from "ramda";

import {
  disconnectCompanySocialAccount,
  DISCONNECT_COMPANY_SOCIAL_ACCOUNT
} from "../../../store/actions/company";
import MultipostingModalHelper from "../../Opportunity/routes/OpportunityDetails/MultipostingForm/MultipostingModalHelper";

import IntegrationModal from "./IntegrationModal";
import Account from "./Account";
import { multipostingAccounts, scraperAccounts } from "./AccountList";

import styled from "styled-components/macro";

const Accounts = styled.div`
  display: flex;
  flex-wrap: wrap;

  h1 {
    width: 100%;
    margin-top: 1em;
  }
`;

const AccountsContainer = styled.section`
  display: block;
  p {
    width: 100%;
  }
`;

const Portals = styled.section`
  display: block;
  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    > div {
      width: 32%;
      margin-right: 18px;
      margin-bottom: 18px;
    }
  }
`;

const Disabled = styled.div`
  position: absolute;
  background: #f7f9fa;
  height: 100%;
  width: 100%;
  z-index: 1;
  opacity: 0.6;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const SocialAccounts = ({ accounts = {}, company, isLoadingScraper }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showMultipostingModal, setShowMultipostingModal] = React.useState(
    false
  );
  const [MultipostingModal, setMultipostingModal] = React.useState(null);
  const [showScraperModal, setShowScraperModal] = React.useState(false);
  const [integrationType, setIntegrationType] = React.useState({});

  const isLoadingMultiposting = useSelector(
    R.path(["company", "socialAccounts", "loading"])
  );

  const disconnectFromAccount = React.useCallback(
    provider => dispatch(disconnectCompanySocialAccount(provider)),
    [dispatch]
  );

  return (
    <>
      {!company.allowMultiposting && (
        <p>{t("opportunity:wizard.multiposting.isNotPublic")}</p>
      )}
      <div style={{ position: "relative" }}>
        {!company.allowMultiposting && <Disabled />}
        <AccountsContainer>
          <Portals>
            <h1>{t("opportunity:wizard.multiposting.titleJob")}</h1>
            <p>{t("company:socialMedia.description")}</p>
            <Accounts>
              <h1>{t("opportunity:wizard.multiposting.simpleTitleJob")}</h1>
              {multipostingAccounts.map(item => (
                <Account
                  key={item.provider}
                  provider={item.provider}
                  logo={item.logo}
                  account={accounts[item.provider]}
                  country={item.country}
                  flag={item.flag}
                  isLoading={isLoadingMultiposting === item.provider}
                  isDisabled={
                    isLoadingMultiposting &&
                    isLoadingMultiposting !== item.provider
                  }
                  onConnect={() => {
                    setMultipostingModal(item.modal);
                    setIntegrationType(item);
                    setShowMultipostingModal(true);
                  }}
                  onDisconnect={() => {
                    setMultipostingModal(item.modal);
                    setIntegrationType(item);
                    disconnectFromAccount(item.provider);
                  }}
                  connectedTo={
                    accounts[item.provider] &&
                    item.connectedTo(company.socialAccounts[item.provider])
                  }
                />
              ))}
              <h1 style={{ marginTop: 28, display: "flex" }}>
                {t("opportunity:wizard.multiposting.integrations.mainTitle")}
              </h1>
              <MultipostingModalHelper />
              <p>
                {t(
                  "opportunity:wizard.multiposting.integrations.mainDescription"
                )}
              </p>
              {scraperAccounts.map(item => (
                <Account
                  modeOtherIntegrations
                  key={item.provider}
                  provider={item.provider}
                  logo={item.logo}
                  account={accounts[item.provider]}
                  country={item.country}
                  flag={item.flag}
                  isLoading={isLoadingScraper && integrationType === item}
                  isDisabled={isLoadingScraper && integrationType !== item}
                  onConnect={() => {
                    setIntegrationType(item);
                    setShowScraperModal(true);
                  }}
                  onDisconnect={() => {
                    setIntegrationType(item);
                    disconnectFromAccount(item.provider);
                  }}
                  connectedTo={{
                    name: t(
                      "opportunity:wizard.multiposting.integrations.account." +
                        item.name +
                        ".title"
                    )
                  }}
                />
              ))}
            </Accounts>
            {showMultipostingModal && (
              <MultipostingModal
                type={integrationType}
                onClose={() => setShowMultipostingModal(false)}
              />
            )}
            {showScraperModal && (
              <IntegrationModal
                type={integrationType}
                onClose={() => setShowScraperModal(false)}
              />
            )}
          </Portals>
        </AccountsContainer>
      </div>
    </>
  );
};

const enhancer = compose(
  connect(({ company }) => ({
    company
  })),
  connect(state => ({
    isLoadingScraper:
      DISCONNECT_COMPANY_SOCIAL_ACCOUNT.getStatus(state) === "pending"
  }))
);

export default enhancer(SocialAccounts);
